import React from 'react';
import Fjernlager from '../../../../Fjernlager';
import { Col } from '../../../../grid';
import { Paragraph } from '../../../../typography';

const RenderModularText = ({
  inStock,
  showModularText,
}) => {
  if (showModularText) {
    return (
      <Col xs={12}>
        {inStock <= -2 && (
        <Paragraph blue paddingTop="5px" grey={inStock === '-1'}>
          <Fjernlager inStock={inStock} />
        </Paragraph>
        )}
        <Paragraph paddingTop="5px" grey={inStock === '-1'} fontSize="12px">
          Modular 20 fustage. Kræver eget Modular 20 anlæg. Vi udlejer ikke udstyret til disse fustager. Lagerføres ikke, tages kun hjem på bestilling og mod forud betaling, ingen returret.
        </Paragraph>
      </Col>
    );
  }
  return (null);
};

// Export
export default RenderModularText;
